module.exports = __webpack_public_path__ + "media/images/csr_pc-fb98e2f2b3fe08fbe58b758ddb0782d5.png";